module.exports = __webpack_public_path__ + "static/media/gamers.6a6aa18f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wish-list/gamers.jpg
// module id = 1068
// module chunks = 0